import { Injectable } from '@angular/core'
import { MbCheckoutContactDetailsAdapter } from './mb-checkout-contact-details.adapter'
import { MbCheckoutContactDetailsModel } from '../../../models'

@Injectable({
  providedIn: 'root',
})
export class MbCheckoutContactDetailsConnector {

  constructor (protected adapter: MbCheckoutContactDetailsAdapter) {
  }

  get (cartID: string) {
    return this.adapter.load(cartID)
  }

  post (form: MbCheckoutContactDetailsModel, cartID: string) {
    return this.adapter.post(form, cartID)
  }
}
